module.exports = __webpack_public_path__ + "static/media/background-new.5d9745ba.png";